<template>
  <div class="fixed top-14 left-0 right-0 w-screen z-40">
    <div class="flex flex-col gap-2">
      <div
        v-for="messageObj in messages"
        :key="messageObj.id">
        <NotificationItem
          :message="messageObj.message"
          :type="messageObj.type"
          :id="messageObj.id"
          @close="onClose"
        />
      </div>
    </div>
  </div>
</template>

<script>
import notifications from '../services/notifications.js'
import NotificationItem from './items/NotificationItem.vue'

import { watch } from 'vue'

export default {
  components: {
    NotificationItem,
  },
  props: {},
  data() {
    return {
      messages: [],
    }
  },
  eventCallbackIds: {},
  methods: {
    // onPageSelected() {
    //   this.$refs.pagesNavbarDropdown.closeMenu()
    // }
    onClose(notificationId) {
      notifications.clearNotification(notificationId)
    }
  },
  created() {
    // this.$options.eventCallbackIds.operationsSettingsFormUpdate = events.register(
    //   'operationsSettingsFormUpdate',
    //   () => {
    //     this.updateUser()
    //   }
    // )
    this.messages = notifications._vars.notifications
    watch(notifications._vars.notifications, (newValue) => {
      console.log('new message', newValue)
      this.messages = newValue
    })
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    // events.remove(
    //   'operationsSettingsFormUpdate',
    //   this.$options.eventCallbackIds.operationsSettingsFormUpdate
    // )
  }
}
</script>
